import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default class StatusIndicator extends React.Component {
    render() {
        if (this.props.isOnline) {
            return (
                <span className="status-indicator" data-online>
                    <FormattedMessage id="online" />
                </span>
            );
        } else {
            return null;
        }
    }
}

StatusIndicator.propTypes = {
    isOnline: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/status-indicator.jsx